export default __webpack_public_path__ + "static/media/rings.1fb0b3cd.png";